export const environment = {
  production: true,
  appDomain: 'https://app.matheo.pro',
  expertChatApi: 'https://expertchat.fx2.io',
  expertChatSocket: 'wss://ws.expertchat.fx2.io',
  // expertChatEventSocket: 'wss://track-ws.fx2.io',
  socketKey: '9f9143b2df1defcd339e',
  socketCluster: 'mt1',
};
